module.exports = __webpack_public_path__ + "img/20190701160742787.d8ca8c83.png";